// extracted by mini-css-extract-plugin
module.exports = {"Leftbar":"Leftbar_Leftbar__24Jbx","bottom-menu":"Leftbar_bottom-menu__2QYHs"};